import type { ComponentType } from 'react';
import { SchemaFieldIcon } from '@rossum/components/schema-field-icon/SchemaFieldIcon';
import {
  IconAlertTriangle,
  IconBolt,
  IconServerBolt,
  IconWebhook,
} from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Typography } from '@rossum/ui/material';
import { fieldIconType } from './fieldIconType';

type SearchOptionItemProps = {
  option: string;
  type: string | undefined;
  liProps: React.HTMLAttributes<HTMLLIElement>;
};

const ICON_CONFIG: Record<
  string,
  { Icon: ComponentType; color?: 'error' | 'inherit' }
> = {
  external: { Icon: IconAlertTriangle, color: 'error' },
  rule: { Icon: IconBolt },
  function: { Icon: IconServerBolt },
  webhook: { Icon: IconWebhook },
};

const OptionIcon = ({ type }: { type: string | undefined }) => {
  if (!type) return null;

  const config = ICON_CONFIG[type];
  if (config) {
    return (
      <SvgIcon
        color={config.color}
        sx={config.color ? undefined : { color: 'text.secondary' }}
      >
        <config.Icon />
      </SvgIcon>
    );
  }

  const iconType = fieldIconType(type);
  if (iconType) return <SchemaFieldIcon type={iconType} />;

  return null;
};

export const SearchOptionItem = ({
  option,
  type,
  liProps,
}: SearchOptionItemProps) => (
  <li {...liProps}>
    <Stack direction="row" spacing={1} alignItems="center">
      <OptionIcon type={type} />
      <Typography variant="body1">{option}</Typography>
    </Stack>
  </li>
);
